/** Long emails, URLs, and names must stay inside their card. */
const WRAP_TEXT = {
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
  minWidth: 0,
  maxWidth: '100%',
};

module.exports = { WRAP_TEXT };
